/*
    Description: The dialog confirming that you mean to close the modal if there were changes inside of it
*/
import React, { FC } from 'react';

type Props = {
    onCloseClicked: () => any; // The user chose that they knew what they were doing and want to close the whole modal
    onDismissClicked: () => any; // The user is closing just this dialog - they do not want to close the modal
    open: boolean;
};

const NoFormModal = ({
    buttons,
    content,
    heading,
    id,
    onClickOutside,
    open,
}: {
    buttons?: React.ReactElement[];
    content: React.ReactElement[];
    heading: string;
    id: string; // unique ID
    onClickOutside?: () => any;
    open: boolean;
}) => (
    <dialog className="modal" id={id} open={open}>
        <div className="modal-box">
            <h3 className="text-lg font-bold">{heading}</h3>
            <div className="py-4">{content}</div>
            <div className="modal-action">{buttons}</div>
        </div>
        <label
            aria-hidden
            className="modal-backdrop"
            htmlFor={id}
            onClick={() => {
                if (onClickOutside) onClickOutside();
            }}
        >
            Close
        </label>
    </dialog>
);

/**
 * The dialog confirming that you mean to close the modal if there were changes inside of it
 * @param param0
 * @param param0.children The children of this component.
 * @param param0.onCloseClicked
 * @param param0.onDismissClicked
 * @param param0.open
 * @returns
 */
export const CloseModalConfirmationDialog: FC<Props> = ({
    onCloseClicked,
    onDismissClicked,
    open,
}: Props): React.ReactElement => {
    return (
        <>
            <div className="fixed z-[5000]">
                <NoFormModal
                    buttons={[
                        <button
                            className="btn btn-outline btn-primary"
                            key="dismiss-button"
                            onClick={onDismissClicked}
                            type="button"
                        >
                            Dismiss
                        </button>,
                        <button
                            className="btn btn-primary"
                            key="close-button"
                            onClick={onCloseClicked}
                            type="button"
                        >
                            Close
                        </button>,
                    ]}
                    content={[
                        <p key="first-paragraph">
                            You will lose any progress if you choose to close
                            this window. Are you sure?
                        </p>,
                    ]}
                    heading="Are you sure?"
                    id="are-you-sure-dialog"
                    onClickOutside={onDismissClicked}
                    open={open}
                />
            </div>
        </>
    );
};
